<template lang="html">
  <div class="row">
    <div class="col-lg-12 lbv-event-history">
      <b-card header="Events">
        <!--<b-table striped :items="eventHistory" :fields="eventHistoryFields"></b-table>-->
        <table
          cellspacing="0"
          aria-busy="false"
          class="table b-table table-striped"
        >
          <tr>
            <th v-for="col in eventHistoryFields">
              {{ col.label }}
            </th>
          </tr>
          <tbody>
            <template v-for="(event, index) in eventHistory">
              <tr
                v-if="event.derived_event_closed === 'null'"
                class="table-is-open"
                @click.stop="rowClicked(index)"
              >
                <td class="table-status">
                  {{ event.status }}
                </td>
                <td>{{ event.derived_event_created }}</td>
                <td>{{ nullFormatter(event.derived_event_closed) }}</td>
                <td>{{ durationFormatter(event) }}</td>
                <td>{{ typeTranslation(event.Type) }}</td>
                <td>{{ event.derived_event_code }}</td>
                <td>{{ actionTranslation(event.crm_business_name) }}</td>
                <td>{{ nullFormatter(event.crm_business_created) }}</td>
              </tr>
              <tr
                v-else="event.derived_event_closed !== 'null'"
                class="table-is-closed"
              >
                <td class="table-status">
                  {{ event.status }}
                </td>
                <td>{{ event.derived_event_created }}</td>
                <td>{{ nullFormatter(event.derived_event_closed) }}</td>
                <td>{{ durationFormatter(event) }}</td>
                <td>{{ typeTranslation(event.Type) }}</td>
                <td>{{ event.derived_event_code }}</td>
                <td>{{ actionTranslation(event.crm_business_name) }}</td>
                <td>{{ nullFormatter(event.crm_business_created) }}</td>
              </tr>
              <template v-if="event.interaction_flag !== 'null'">
                <tr v-for="item in event.interaction_flag.split('|')">
                  <td
                    colspan="1"
                    class="child-arrow"
                  >
                    ↳
                  </td>
                  <td colspan="3">
                    {{ item.split(',')[1] }}
                  </td>
                  <td colspan="1">
                    App
                  </td>
                  <td colspan="4">
                    {{ item.split(',')[0] }}
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
        <b-button
          class="page prev"
          variant="primary"
          size="sm"
          :disabled="pageNumber === 1"
          @click.prevent="page"
        >
          Prev
        </b-button>

        <b-button
          class="page next"
          variant="primary"
          size="sm"
          :disabled="!hasNextPage"
          @click.prevent="page"
        >
          Next
        </b-button>
        <div class="current-page">
          Page: {{ pageNumber }}
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { TabNavEvent } from '../../events/tabNavEvent'
import { APIEvent } from '../../events/apiEvent'
import { StatusBarEvent } from '../../events/statusBarEvent'
import { EventBus } from '../../event-bus'
import { CUSTOMER_LABEL } from '../../constants/customerEvents/customerEventLabels'
import * as ROLES from '../../constants/roles'
import { PERMISSIONS } from '../../constants/permissions/permissions'

export default {
  name: 'EventsView',
  data () {
    return {
      PERMISSIONS,
      rowClickState: [],
      eventHistoryFields: [
        {
          key: 'status',
          label: 'Status',
          sortable: false
        },
        {
          key: 'derived_event_created',
          sortable: false,
          label: 'Opened'
        },
        {
          key: 'derived_event_closed',
          sortable: false,
          label: 'Closed',
          tdClass: 'custom-td-width',
          formatter: this.nullFormatter
        },
        {
          key: 'duration',
          sortable: false,
          label: 'Duration',
          tdClass: 'custom-td-width',
          formatter: this.durationFormatter
        },
        {
          key: 'Type',
          sortable: false,
          label: 'Type',
          formatter: this.typeTranslation
        },
        {
          key: 'derived_event_code',
          sortable: false,
          label: 'Event'
        },
        {
          key: 'crm_business_name',
          label: 'CRM Action',
          sortable: false,
          tdClass: 'custom-td-width',
          formatter: this.actionTranslation
        },
        {
          key: 'crm_business_created',
          label: 'CRM Action Date',
          sortable: false,
          tdClass: 'custom-td-width',
          formatter: this.nullFormatter
        }
      ],
      eventHistory: [],
      perPage: 10,
      startOffset: 0,
      hasNextPage: false,
      pageNumber: 1
    }
  },
  mounted () {
    this.lb_id = this.$route.params.LbDevice_ID
    this.fetchDeviceEvents()
    EventBus.$on(TabNavEvent.DEVICE_EVENTS, this.fetchDeviceEvents)
    // For Maintenance Manager Tab event is never fired as
    // Events is only tab so let's force it for this role
    if (this.$store.getters.roleID === ROLES.MAINTENANCE || this.$store.getters.roleID === ROLES.INSURANCE ) {
      if (typeof this.lb_id === 'undefined') {
        this.getDeviceId()
      } else {
        this.fetchDeviceEvents()
      }
    }
  },
  destroyed () {
    // EventBus.$off(TabNavEvent.DEVICE_EVENTS, this.fetchDeviceEvents)
    this.eventHistory = []
    this.perPage = 10
    this.hasNextPage = false
    this.pageNumber = 1
    this.startOffset = 0
  },
  methods: {
    rowClicked: function (index) {
      this.$set(this.rowClickState, index, !this.rowClickState[index])
    },
    fetchDeviceEvents: function (leakBotId) {
      let options = {}
      options.LbDevice_ID = leakBotId || this.lb_id
      options.fetch_size = this.perPage.toString()
      options.start_record = this.startOffset.toString()
      this.$store.dispatch(APIEvent.FETCH_DERIVED_EVENTS_VIEW, options)
        .then((res) => {
          this.eventHistory = this.prepareDataForTable(res.data.list.records)
          this.hasNextPage = res.data.LastPage === '0'
        })
        .catch((error) => {
          EventBus.$emit(StatusBarEvent.ERROR, error.message)
        })
    },
    prepareDataForTable: function (events) {
      for (var i = 0; i < events.length; i++) {
        let event = events[i]
        event._cellVariants = { status: 'status' }
        if (event.derived_event_closed === 'null') {
          event.status = 'Open'
          event._rowVariant = 'is-open'
        } else {
          event.status = 'Closed'
          event._rowVariant = 'is-closed'
        }
        // TODO: add additional logic for child events / interactions
      }
      return events
    },
    page (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        this.startOffset += this.perPage
        this.pageNumber += 1
      } else {
        this.startOffset -= this.perPage
        this.pageNumber -= 1
      }
      this.fetchDeviceEvents()
    },
    nullFormatter: function (value) {
      return (value === 'null' || value === 'NA') ? '-' : value
    },
    durationFormatter: function (item) {
      let start = new Date(item.derived_event_created).getTime()
      // if item is not closed, use today's date
      let end = item.derived_event_closed === 'null'
        ? new Date().getTime()
        : new Date(item.derived_event_closed).getTime()
      return Math.round(((end - start) / 86400) / 1000)
    },
    actionTranslation: function (value) {
      return CUSTOMER_LABEL[value]
    },
    typeTranslation: function (value) {
      return 'Event'
    },
    getDeviceId: function () {
      let id = this.$route.params.deviceID
      this.$store.dispatch(APIEvent.FETCH_DEVICE, id)
        .then((res) => {
          let leakbotId = res.data.Device.lb_id
          this.fetchDeviceEvents(leakbotId)
        })
    }
  }
}
</script>

<style lang="css">
.pagination {
  width: 100%;
}

.child-arrow {
  font-size: 1.3rem;
}
 .card {
  border-radius: 8px;
 }
.card-header{
  background-color: #ccf4f1;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: none;
  font-weight: 600;
}

</style>
